import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '施工前需要準備什麼？',
      answer: '只需預約諮詢，我們會協助評估與規劃。您可以先準備好想要的風格參考圖片、預算範圍，以及對空間的使用需求。我們的專業團隊會根據您的需求提供最適合的方案。',
    },
    {
      question: '是否提供保固？',
      answer: '是的，我們提供防水保證和施工保證。防水工程提供3年保固，我們其他施工項目提供1-2年保修。保修期間內如有任何問題，都會免費處理。',
    },
    {
      question: '可以只做浴室嗎？',
      answer: '當然可以！我們提供單一工程服務，不論是浴室改造、廚房翻新，或是局部空間的裝修，都能為您服務。我們會根據您的需求提供最適合的方案與報價。',
    },
    {
      question: '施工期間可以居住嗎？',
      answer: '這取決於施工的範圍。如果是局部裝修（如單一浴室），通常可以繼續居住。但如果是全室裝修，為了施工效率和您的生活品質，建議暫時搬離。我們會在評估時給您專業建議。',
    },
    {
      question: '如何計算裝修費用？',
      answer: '裝修費用會根據施工範圍、材料選擇、設計複雜度等因素而定。我們會在現場勘查後，提供詳細的報價單，包含所有項目的明細，讓您清楚了解每一筆費用。我們堅持透明報價，不會有隱藏費用。',
    },
    {
      question: '付款方式如何安排？',
      answer: '採分期付款方式：承包商時支付訂金，施工階段支付工程款，完工驗收後支付尾款。具體付款方式將在合約中明確載明。',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-warm-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-primary mb-4 font-serif">
            常見問題
          </h2>
          <p className="text-base text-gray-600">解答您對裝修的疑問</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-md transition-shadow"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-warm-50/50 transition-colors"
                aria-expanded={openIndex === index}
              >
                <h4 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h4>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full bg-[#4A90C2]/10 flex items-center justify-center transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-xl text-[#1E4D7B]"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-sm text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
}